import React from "react";
import PropTypes from "prop-types";

import { Modal, Content, Select, OptionSelect } from "./styles";

const ModalSetStatus = ({ modalOpen, setModalOpen, updateForm }) => {
  const onHandleChange = (value) => {
    updateForm(value);
    setModalOpen(false);
  };

  return modalOpen ? (
    <Modal onClick={() => setModalOpen(false)}>
      <Content onClick={(event) => event.stopPropagation()}>
        <Select onChange={(e) => onHandleChange(e.target.value)}>
          <OptionSelect value="">Selecciona</OptionSelect>
          <OptionSelect value="AFFILIATE">Afiliado</OptionSelect>
          <OptionSelect value="NOT_AFFILIATE">No afiliado</OptionSelect>
          <OptionSelect value="PENDING_REQUEST">Pendiente</OptionSelect>
        </Select>
      </Content>
    </Modal>
  ) : (
    <></>
  );
};

ModalSetStatus.propTypes = {
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
  updateForm: PropTypes.func,
};

export default ModalSetStatus;
